(function () {
  if (window.__subsTabWired) {
    return;
  }

  window.__subsTabWired = true;

  const container = document.getElementById("subscriptions_container");
  if (!container) {
    return;
  }

  const proxyBase = container.getAttribute("data-app-proxy-base") || "/apps/proxy";
  const customerId = container.getAttribute("data-customer-id") || "";
  const locale = container.getAttribute("data-locale") || "en-GB";
  const currency = container.getAttribute("data-currency") || "GBP";
  const successColor = container.getAttribute("data-success-color") || "#16a34a";
  const failureColor = container.getAttribute("data-failure-color") || "#dc2626";
  const isDesignMode = container.getAttribute("data-design-mode") === "true";
  const showEmptyState = container.getAttribute("data-show-empty-state") === "true";

  const selectById = (id) => document.getElementById(id);

  const SubsLoadingElement = selectById("subs-loading");
  const SubsErrorElement = selectById("subs-error");
  const NoContractsElement = selectById("subs-no-contracts");
  const ContractsExistElement = selectById("subs-contracts-exist");
  const SubscriptionHistoryContainer = selectById("subs-history-list-container");

  let currentContract = null;
  let allContracts = [];
  let allPaymentMethods = [];

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const ensureDataReady = async () => {
    let tries = 0;
    while (!currentContract && tries < 40) {
      await sleep(50);
      tries++;
    }
  };

  // toast helper
  const toastShow = (msg) => {
    const wrap = selectById("subs-toast");
    const body = selectById("subs-toast-body");

    if (!wrap || !body) return;

    body.textContent = msg || "";

    // Ensure visible
    wrap.classList.remove("hidden");
    wrap.classList.add("show");

    // Auto-hide after delay
    setTimeout(() => {
      try {
        wrap.classList.remove("show");
        wrap.classList.add("hidden");
      } catch (_) {}
    }, 2400);
  };

  // Translations helper
  const T = (key, fallback) => (window.subsTranslations && window.subsTranslations[key]) || fallback;

  const tpl = (str, vars) => {
    const s = typeof str === "string" ? str : "";

    return s.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, p) => (vars && p in vars ? String(vars[p]) : ""));
  };

  const moneyMajor = (amount) => {
    if (amount === null || amount === undefined || amount === "") return "—";

    const num = typeof amount === "string" ? parseFloat(amount) : amount;

    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency, currencyDisplay: "narrowSymbol" }).format(
        num
      );
    } catch (_) {
      return `${num}`;
    }
  };

  const formatDate = (isoOrTimestampSeconds) => {
    if (!isoOrTimestampSeconds) return "";

    let date;

    switch (typeof isoOrTimestampSeconds) {
      case "string":
        date = new Date(isoOrTimestampSeconds);
        break;
      case "number":
        date = new Date(isoOrTimestampSeconds * 1000);
        break;
      case "object":
        if (isoOrTimestampSeconds._seconds) {
          date = new Date(isoOrTimestampSeconds._seconds * 1000);
        }
        break;
    }

    if (!date) return "";

    return date.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" });
  };

  // Format phone number helper (use global if available, otherwise basic fallback)
  const formatPhoneNumberLocal = (phoneNumber) => {
    if (!phoneNumber) return "";

    // Use global formatPhoneNumber if available (from esim.js.liquid)
    if (typeof window.formatPhoneNumber === "function") {
      return window.formatPhoneNumber(phoneNumber);
    }

    // Basic fallback formatting
    return "+" + phoneNumber.replace(/(\d{2})(\d{4})(\d+)/, "$1 $2 $3");
  };

  // Map bundle/SKU to friendly variant name
  const getFriendlyName = (bundleOrSku) => {
    if (!bundleOrSku) return "";

    try {
      const index = window.subsVariantIndex || {};
      const variants = index[bundleOrSku] || [];

      // Find the specific variant that matches this SKU
      const variant = variants.find((v) => v.sku === bundleOrSku);

      return variant?.title || bundleOrSku;
    } catch (_) {
      return bundleOrSku;
    }
  };

  // Initialize shared SubscriptionActions module
  if (window.SubscriptionActions) {
    window.SubscriptionActions.init({
      proxyBase,
      customerId,
      locale,
      currency,
      translations: window.subsTranslations || {},
      getCurrentContract: () => currentContract,
      onContractUpdated: async (updatedContract) => {
        // Refresh contract data and update UI
        if (updatedContract) {
          currentContract = updatedContract;
        } else {
          // If no contract provided, refresh from API
          try {
            const contracts = await api("api/list-contracts");
            const allContracts = contracts?.data?.contracts || contracts?.contracts || [];
            currentContract = allContracts.find((c) => c?.iccid === currentContract?.iccid) || allContracts[0] || null;
          } catch (e) {
            // Silently fail - currentContract remains unchanged
          }
        }
        render.plan(selectById("subs-current-plan-card"), currentContract);
        render.bills(currentContract?.latestBill, currentContract?.nextBill);

        // Update payment method display if needed
        if (currentContract) {
          const pm = (allPaymentMethods || []).find((m) => m.id === currentContract?.paymentMethodId) || null;
          const pmToRender = pm || (allPaymentMethods.length > 0 ? allPaymentMethods[0] : null);
          if (pmToRender) {
            render.payment(pmToRender, pmToRender?.status != "ACTIVE");
          }
        }
      },
      onError: (msg) => {
        console.error("Subscription error:", msg);
        toastShow(T("toastError", "Something went wrong. Please try again."));
      },
    });
  }

  // Use shared API if available, otherwise fallback to local implementation
  const api =
    window.SubscriptionActions && typeof window.SubscriptionActions.api === "function"
      ? window.SubscriptionActions.api.bind(window.SubscriptionActions)
      : async (path, params = {}) => {
          const normalized = path.replace(/^\/+/, "");

          const url = new URL(`${proxyBase}/${normalized}`, window.location.origin);

          if (customerId) url.searchParams.set("logged_in_customer_id", customerId);

          Object.entries(params).forEach(([k, v]) => v != null && url.searchParams.set(k, v));

          try {
            const res = await fetch(url.toString(), { credentials: "include" });

            if (!res.ok) {
              const errorText = await res.text();
              throw new Error(`Request failed ${res.status}: ${errorText}`);
            }

            const data = await res.json();

            return data;
          } catch (error) {
            throw error;
          }
        };

  const render = {
    plan(_el, contract) {
      if (!contract) {
        return;
      }
      // Use friendly variant name from Shopify, fallback to bundle code, then MSISDN
      const bundleCode = contract?.bundle || contract?.sku;
      const planName = getFriendlyName(bundleCode) || contract?.msisdn || "Subscription";

      selectById("subs-plan-name").textContent = planName;
      selectById("subs-plan-status").textContent = contract?.status || "";

      const renew = contract?.contractRenewalDate || contract?.nextBillingAttemptDate || null;

      selectById("subs-plan-renews-date").textContent = renew ? `${formatDate(renew)}` : "";

      // show/hide actions and labels depending on status
      selectById("subs-plan-actions").style.display = contract?.status === "CANCELLED" ? "none" : "flex";
      selectById("subs-plan-renews-date-container").style.display = contract?.status === "CANCELLED" ? "none" : "flex";

      // show/hide latest/next bill gracefully; allow layout to adapt via flex
      const hasAttempt = Boolean((currentContract?.attempts || []).at(0)?.createdAt);
      const isCancelled = contract?.status === "CANCELLED";

      const latest = selectById("subs-latest-bill");
      const next = selectById("subs-next-bill");

      if (latest) latest.style.display = hasAttempt ? "" : "none";

      if (next) next.style.display = isCancelled ? "none" : "";

      // plan change banner
      const changeBanner = selectById("subs-plan-change-banner");
      const changeText = selectById("subs-plan-change-text");
      const hasScheduled = Boolean(contract?.nextBundleEffectiveAt) && contract.status !== "CANCELLED";

      if (changeBanner) {
        if (hasScheduled) {
          changeBanner.classList.remove("hidden");
          changeBanner.style.display = "flex";

          const txt = tpl(T("bannerPlanChangeScheduled", "Your plan change is scheduled on {{date}}."), {
            date: formatDate(contract?.nextBundleEffectiveAt),
          });

          if (changeText) changeText.textContent = txt;
        } else {
          changeBanner.style.display = "none";
          changeBanner.classList.add("hidden");
        }
      }
    },
    bills(latest, next) {
      // Plan labels (from API or sku map with friendly names)
      const currentBundleCode = currentContract?.bundle || currentContract?.sku;
      const planLabel = getFriendlyName(currentBundleCode) || currentContract?.msisdn || "Subscription";

      selectById("subs-latest-bill-plan").textContent = planLabel;

      // For next bill, use nextBundle if scheduled, otherwise current
      const nextBundleCode = currentContract?.nextBundle || currentBundleCode;
      const nextLabel = getFriendlyName(nextBundleCode) || planLabel;

      selectById("subs-next-bill-plan").textContent = nextLabel;

      const latestAttempt = (currentContract?.attempts || []).at(0);

      // Derive from contract attempts and contract fields
      const latestDate = latest ? latest : latestAttempt?.createdAt || null;

      selectById("subs-latest-bill-date").textContent = latestDate ? formatDate(latestDate) : "";
      selectById("subs-latest-bill-amount").textContent = moneyMajor(currentContract?.price ?? null);

      const statusEl = selectById("subs-latest-bill-status");
      const statusText =
        latestAttempt?.status === "SUCCESS"
          ? T("paid", "Paid")
          : latestAttempt?.status == "FAILURE"
          ? T("failed", "Failed")
          : latestAttempt?.status || "";

      const statusColor = latestAttempt?.status === "SUCCESS" ? successColor : failureColor;

      statusEl.textContent = statusText;
      statusEl.style.color = statusColor;

      const nextDate = next
        ? next
        : currentContract?.nextBundleEffectiveAt ||
          currentContract?.nextBillingAttemptDate ||
          currentContract?.contractRenewalDate;

      selectById("subs-next-bill-date").textContent = nextDate ? formatDate(nextDate) : "";

      const nextAmount = currentContract?.nextBundlePrice ?? currentContract?.price ?? null;

      selectById("subs-next-bill-amount").textContent = moneyMajor(nextAmount);
      selectById("subs-next-bill-note").textContent = nextDate
        ? tpl(T("paymentWillBeTakenOn", "Payment will be taken on {{date}}"), { date: formatDate(nextDate) })
        : "";
    },

    payment(m, expired) {
      if (!m) {
        return;
      }

      const brand = m?.brand?.toUpperCase?.() || "CARD";
      const last4 = m?.last4 || "****";

      const exp =
        m?.expiryMonth && m?.expiryYear
          ? `${String(m.expiryMonth).padStart(2, "0")}/${String(m.expiryYear).slice(-2)}`
          : "—";

      const holder = m?.name || "—";

      // Update brand
      const brandEl = selectById("subs-card-brand");
      if (brandEl) brandEl.textContent = brand;

      // Update card number
      const last4El = selectById("subs-card-last4-big");
      if (last4El) last4El.textContent = `•••• •••• •••• ${last4}`;

      // Update expiry
      const expEl = selectById("subs-card-exp");
      if (expEl) expEl.textContent = exp;

      // Update cardholder (uppercase for card display)
      const holderEl = selectById("subs-card-holder");
      if (holderEl) holderEl.textContent = holder.toUpperCase();

      // Update caption
      const captionEl = selectById("subs-card-caption");
      if (captionEl) {
        captionEl.textContent = m?.id
          ? tpl(T("cardCaptionWithLast4", "This subscription is linked to a card ending {{last4}}"), { last4 })
          : "";
      }

      // Handle expired banner
      const banner = selectById("subs-expired-banner");

      if (expired) {
        banner?.classList.remove("hidden");
      } else {
        banner?.classList.add("hidden");
      }
    },
    history(attempts) {
      const yearSelect = selectById("subs-history-year");
      const rowsWrap = selectById("subs-history-rows");

      if (!yearSelect || !rowsWrap) {
        return;
      }

      const years = Array.from(new Set((attempts || []).map((a) => formatDate(a?.createdAt)?.slice(-4))))
        .filter(Boolean)
        .sort((a, b) => b - a);

      yearSelect.innerHTML = years
        .map((y) => `<option value="${y}">${tpl(T("yearLabel", "Year {{year}}"), { year: y })}</option>`)
        .join("");
      const renderRows = (year) => {
        const filtered = year ? attempts.filter((a) => formatDate(a?.createdAt).endsWith(year)) : attempts;

        const bundleCode = currentContract?.bundle || currentContract?.sku;
        const planName = getFriendlyName(bundleCode) || currentContract?.msisdn || "Subscription";
        const html = (filtered || [])
          .map((attempt) => {
            const statusText = attempt?.status === "SUCCESS" ? T("paid", "Paid") : T("failed", "Failed");
            const statusColor = attempt?.status === "SUCCESS" ? successColor : failureColor;

            return `
          <div class="subs-history-row">
            <div>
              <div class="subs-history-date">${formatDate(attempt?.createdAt)}</div>
              <div class="subs-history-plan">${planName}</div>
            </div>
            <div class="flex items-center gap-6">
              <div class="subs-history-amount">${moneyMajor(currentContract?.price)}</div>
              <div class="subs-history-status" style="color: ${statusColor};">${statusText}</div>
            </div>
          </div>`;
          })
          .join("");

        rowsWrap.innerHTML = html;
      };
      renderRows("");
      yearSelect.onchange = (e) => renderRows(e.target.value);
    },
  };

  // Use shared modal helper if available
  const showModal =
    window.SubscriptionActions?.showModal?.bind(window.SubscriptionActions) ||
    ((title, bodyHTML, onConfirm) => {
      const backdrop = selectById("subs-modal-backdrop");
      const modal = selectById("subs-modal");
      selectById("subs-modal-title").textContent = title;
      selectById("subs-modal-body").innerHTML = bodyHTML;
      backdrop.classList.remove("hidden");
      backdrop.classList.add("flex");
      modal.classList.remove("hidden");

      const cleanup = () => {
        const confirmBtn = selectById("subs-modal-confirm");
        if (confirmBtn) {
          confirmBtn.disabled = false;
          confirmBtn.textContent = T("modalConfirm", "Confirm");
        }
        backdrop.classList.add("hidden");
        backdrop.classList.remove("flex");
        modal.classList.add("hidden");
        selectById("subs-modal-confirm").onclick = null;
        selectById("subs-modal-cancel").onclick = null;
        selectById("subs-modal-close").onclick = null;
      };
      selectById("subs-modal-cancel").onclick = cleanup;
      selectById("subs-modal-close").onclick = cleanup;
      selectById("subs-modal-confirm").onclick = async () => {
        try {
          await onConfirm?.();
        } finally {
          cleanup();
        }
      };
    });

  // All subscription actions (cancel, change plan, update payment) are handled by
  // subscriptions-actions.js via global event delegation. No local implementations needed.

  // Helper to render mock data for theme editor preview
  const renderMockData = () => {
    // Build eSIM selector using MSISDN (phone number) as the primary label
    const select = selectById("subs-esim-select");
    if (select) {
      select.innerHTML = (allContracts || [])
        .map((c) => {
          // Try to get full eSIM info from window.accountEsims for better display name
          let label = "Subscription";
          if (window.accountEsims && window.accountEsims.length > 0) {
            const esimData = window.accountEsims.find(e => e.esim?.iccid === c.iccid);
            if (esimData && typeof window.getEsimDisplayName === 'function') {
              label = window.getEsimDisplayName(esimData.esim, esimData.info);
            } else if (c?.msisdn) {
              label = formatPhoneNumberLocal(c.msisdn);
            } else if (c?.iccid) {
              label = c.iccid;
            }
          } else if (c?.msisdn) {
            label = formatPhoneNumberLocal(c.msisdn);
          } else if (c?.iccid) {
            label = c.iccid;
          }
          return `<option value="${c.iccid}">${label}</option>`;
        })
        .join("");

      select.onchange = () => {
        const value = select.value;
        const found = (allContracts || []).find((c) => c.iccid && c.iccid == value);
        currentContract = found || currentContract;

        // Update URL parameter
        if (typeof window.updateIccidInUrl === 'function' && value) {
          window.updateIccidInUrl(value);
        }
        render.plan(selectById("subs-current-plan-card"), currentContract);
        render.bills(null, null);

        const pm = (allPaymentMethods || []).find((m) => m.id === currentContract?.paymentMethodId) || null;
        const pmToRender = pm || (allPaymentMethods.length > 0 ? allPaymentMethods[0] : null);
        if (pmToRender) {
          render.payment(pmToRender, pmToRender?.status != "ACTIVE");
        }

        const attempts = currentContract?.attempts || [];
        if (attempts.length > 0) {
          SubscriptionHistoryContainer?.classList.remove("hidden");
        } else {
          SubscriptionHistoryContainer?.classList.add("hidden");
        }
        render.history(attempts);
      };

      // Check for URL parameter to set initial selection
      const urlIccid = typeof window.getIccidFromUrl === 'function' ? window.getIccidFromUrl() : null;
      if (urlIccid && allContracts.some(c => c.iccid === urlIccid)) {
        select.value = urlIccid;
        // Trigger onchange to render the selected contract
        select.dispatchEvent(new Event('change'));
      } else if (allContracts.length > 0) {
        select.value = allContracts[0].iccid;
        currentContract = allContracts[0] || currentContract;
      }
    }

    render.plan(selectById("subs-current-plan-card"), currentContract);
    render.bills(null, null);

    const pmInit = (allPaymentMethods || []).find((m) => m.id === currentContract?.paymentMethodId) || null;
    const pmToRender = pmInit || (allPaymentMethods.length > 0 ? allPaymentMethods[0] : null);
    if (pmToRender) {
      render.payment(pmToRender, pmToRender?.status != "ACTIVE");
    }

    const attemptsInit = currentContract?.attempts || [];
    if (attemptsInit.length > 0) {
      SubscriptionHistoryContainer?.classList.remove("hidden");
    }
    render.history(attemptsInit);
  };

  const init = async () => {
    try {
      // In theme editor (design mode), use mock data for preview
      if (isDesignMode) {
        SubsLoadingElement?.classList.add("hidden");

        // Developer option: show empty state for styling purposes
        if (showEmptyState) {
          NoContractsElement?.classList.remove("hidden");
          ContractsExistElement?.classList.add("hidden");
          return;
        }

        const mockContracts = window.MOCK_SUBSCRIPTION_CONTRACTS || [];
        const mockPaymentMethods = window.MOCK_SUBSCRIPTION_PAYMENT_METHODS || [];

        if (mockContracts.length < 1) {
          // Show no contracts state if no mock data defined
          NoContractsElement?.classList.remove("hidden");
          ContractsExistElement?.classList.add("hidden");
          return;
        }

        allContracts = mockContracts;
        allPaymentMethods = mockPaymentMethods;
        currentContract = allContracts[0] || null;

        ContractsExistElement?.classList.remove("hidden");
        renderMockData();
        return;
      }

      // Production mode: fetch real data from API
      const [contracts, methods] = await Promise.all([api("api/list-contracts"), api("api/list-payment-methods")]);

      SubsLoadingElement?.classList.add("hidden");

      allContracts = (contracts?.data?.contracts || contracts?.contracts || []).filter((c) => c && c.iccid);

      if (allContracts.length < 1) {
        NoContractsElement?.classList.remove("hidden");
        ContractsExistElement?.classList.add("hidden");

        return;
      }

      ContractsExistElement?.classList.remove("hidden");

      // API response has a 'data' wrapper, so access methods.data.paymentMethods
      allPaymentMethods = methods?.data?.paymentMethods || methods?.paymentMethods || [];

      currentContract = allContracts[0] || null;

      // Build eSIM selector using MSISDN (phone number) as the primary label
      const select = selectById("subs-esim-select");

      select.innerHTML = (allContracts || [])
        .map((c, idx) => {
          // Try to get full eSIM info from window.accountEsims for better display name
          let label = "Subscription";
          if (window.accountEsims && window.accountEsims.length > 0) {
            const esimData = window.accountEsims.find(e => e.esim?.iccid === c.iccid);
            if (esimData && typeof window.getEsimDisplayName === 'function') {
              label = window.getEsimDisplayName(esimData.esim, esimData.info);
            } else if (c?.msisdn) {
              label = formatPhoneNumberLocal(c.msisdn);
            } else if (c?.iccid) {
              label = c.iccid;
            }
          } else if (c?.msisdn) {
            label = formatPhoneNumberLocal(c.msisdn);
          } else if (c?.iccid) {
            label = c.iccid;
          }
          return `<option value="${c.iccid}">${label}</option>`;
        })
        .join("");

      select.onchange = () => {
        const value = select.value;
        const found = (allContracts || []).find((c) => c.iccid && c.iccid == value);

        currentContract = found || currentContract;

        // Update URL parameter
        if (typeof window.updateIccidInUrl === 'function' && value) {
          window.updateIccidInUrl(value);
        }

        // Re-render against the newly selected contract
        render.plan(selectById("subs-current-plan-card"), currentContract);
        render.bills(null, null);

        // Map contract.paymentMethodId to full method from list
        const pm = (allPaymentMethods || []).find((m) => m.id === currentContract?.paymentMethodId) || null;

        // Fallback: if no match found but we have payment methods, use the first one
        const pmToRender = pm || (allPaymentMethods.length > 0 ? allPaymentMethods[0] : null);

        if (pmToRender) {
          render.payment(pmToRender, pmToRender?.status != "ACTIVE");
        }

        // attempts -> history list
        const attempts = currentContract?.attempts || [];

        // Show/hide history container based on whether there are attempts
        if (attempts.length > 0) {
          SubscriptionHistoryContainer?.classList.remove("hidden");
        } else {
          SubscriptionHistoryContainer?.classList.add("hidden");
        }

        render.history(attempts);
      };

      // Check for URL parameter to set initial selection
      const urlIccid = typeof window.getIccidFromUrl === 'function' ? window.getIccidFromUrl() : null;
      if (urlIccid && allContracts.some(c => c.iccid === urlIccid)) {
        select.value = urlIccid;
        // Trigger onchange to render the selected contract
        select.dispatchEvent(new Event('change'));
      } else if (allContracts.length > 0) {
        select.value = allContracts[0].iccid;
        currentContract = allContracts[0] || currentContract;
      }

      render.plan(selectById("subs-current-plan-card"), currentContract);

      render.bills(null, null);

      const pmInit = (allPaymentMethods || []).find((m) => m.id === currentContract?.paymentMethodId) || null;

      // Fallback: if no match found but we have payment methods, use the first one
      const pmToRender = pmInit || (allPaymentMethods.length > 0 ? allPaymentMethods[0] : null);

      if (pmToRender) {
        render.payment(pmToRender, pmToRender?.status != "ACTIVE");
      }

      const attemptsInit = currentContract?.attempts || [];

      if (attemptsInit.length > 0) {
        SubscriptionHistoryContainer?.classList.remove("hidden");
      }

      render.history(attemptsInit);
    } catch (err) {
      SubsLoadingElement?.classList.add("hidden");
      SubsErrorElement?.classList.remove("hidden");
      toastShow(T("toastError", "Something went wrong. Please try again."));
    }
  };

  // Lazy-init when tab is opened
  const maybeInit = () => {
    if (container.dataset.initialized === "1") return;
    container.dataset.initialized = "1";
    init();
  };

  // If opened via query param (?tab=subscriptions), init immediately after DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => {
    const urlParams = new URLSearchParams(window.location.search);
    const isVisible = container.style.display !== "none";

    if (urlParams.get("tab") === "subscriptions" || isVisible) {
      if (typeof openTab === "function") openTab("subscriptions_container");

      maybeInit();
    }
  });

  // Also listen for tab button click using the dedicated button id
  document.addEventListener("click", (e) => {
    const t = e.target.closest("#subscriptions_container_button");

    if (!t) return;

    if (typeof openTab === "function") openTab("subscriptions_container");

    e.preventDefault();

    maybeInit();
  });

  // Action buttons are handled by subscriptions-actions.js via global event delegation
  // This listener ensures the tab is initialized when actions are triggered
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;

    // Ensure subscriptions tab is initialized before shared module handles the action
    maybeInit();
  });

  window.addEventListener("subscription:plan-changed", () => {
    // Refresh plan display when plan change is scheduled
    render.plan(selectById("subs-current-plan-card"), currentContract);
  });
})();
